// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","textBlack":"#161616","customGreyLt":"#f2f2f2","customWhite":"#ffffff","customWhiteDk":"#fafafa","customGrey":"#4b4b4b","footerGrey":"#c0c0c0","borderGreyLt":"#d3d3d3","borderGrey":"#d5dfdf","customBlackLt":"#202020","container":"WCwwI7foWBUXtUS0ktng9","pressed":"IMgMR2j4tdUS6fBPblgPy","disabled":"zC7NnqzvtIis1YlcE0M1T"};


//////////////////
// WEBPACK FOOTER
// ./src/common/simple-button/SimpleButton.css
// module id = 293
// module chunks = 0 1 2